"use client"
import { useMemo } from "react"

export const ShopBackground = () => {
  const victoryBackground = useMemo(() => {
    const backgrounds = ["/images/shop-bg.png", "/images/shop-bg2.png"]
    return backgrounds[Math.floor(Math.random() * backgrounds.length)]
  }, [])

  return (
    <div
      className="absolute inset-0"
      style={{
        backgroundImage: `url(${victoryBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    />
  )
}
